import * as React from "react";
import Routes from '../../components/Routes';
import inventories from '../../routes/inventories'

export default () => {
  return <Routes routes={inventories} />
}